import { type FC } from 'react';

import { useViewport } from '@craft/ui/components/responsive';
import { useMediaQuery } from '@craft/ui/hooks';

import type * as types from './types';

import { DesktopSideNavButton } from './DesktopSideNavButton';
import { MobileSideNavButton } from './MobileSideNavButton';

export const SideNavButton: FC<types.ISideNavButton> = props => {
  const { isMobile, isSmall } = useViewport();
  const hasMinHeightOf400px = useMediaQuery('(min-height:400px)');
  const isMobileLandscapeViewport = !hasMinHeightOf400px && isSmall;

  if (isMobile || isMobileLandscapeViewport) {
    return <MobileSideNavButton {...props} />;
  }
  return <DesktopSideNavButton {...props} />;
};
